<!--
 * @Author: DY
 * @Date: 2025-01-21 11:29:16
 * @LastEditTime: 2025-03-03 11:36:27
 * @Description: 黑龙江分部门计划
 * @FilePath: \ShiMo_Mobile\src\views\configFormRefactoring\departmentalPlan_hlj.vue
-->
<template>
    <div class="procurementPlanSummary">
        <van-nav-bar left-arrow title="采购计划汇总" :style="`height: ${ $getNavHeight() }px;`" @click-left="swiperright"></van-nav-bar>
        <section>
            <table>
                <thead>
                    <tr>
                        <th colspan="3" style="text-align: left;">
                            黑龙江石墨分部门计划
                        </th>
                    </tr>
                    <tr>
                        <th>部门</th>
                        <th>本月采购计划不含税金额（元）</th>
                        <th>本年月均采购不含税金额（元）</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in formData" :key="`applyDeptId_${index}`">
                        <th>{{ item.ApplyDeptName }}</th>
                        <td>{{ item.BudgetTotalMonthNotax }}</td>
                        <td>{{ item.BudgetTotalAvg }}</td>
                    </tr>
                </tbody>
            </table>
        </section>
    </div>
</template>

<script>
export default {
    name: 'procurement-plan-summary',
    components: {},
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.backPathName = from.name;
        });
    },
    data() {
        return {
            listData: {},
            formData: {},
            backPathName: '',
        };
    },
    watch: {},
    filters: {},
    async created() {
        this.listData = this.$route.params.listData;
        this.formData = await this.getFormData(this.listData.FormKeyValue);
    },
    mounted() {},
    computed: {},
    methods: {
        swiperright() {
            this.$router.isBack = 1;
            this.$router.replace({
                name: this.backPathName,
            });
            this.$router.go(-1);
        },
        getFormData(id) {
            const url = `/interfaceApi/procurement/plan_collect_huge/dept/${id}/T2409000002`;
            return this.$axios.$get(url, { token: this.newsToken, defEx: true });
        },
    },
    updated() {},
    destroyed() {},
};
</script>

<style lang="stylus" scoped>
.procurementPlanSummary
    section
        padding 10rpx
        table
            border-collapse: collapse
            th,td
                padding 0 5rpx
                height: 36rpx
                font-size: 14rpx
                color: #333333
                font-weight: 400
                border 1px solid #D7D7D7
            th
                background: #f2f5f6
            tbody
                th
                    width 70rpx
</style>
